import React from "react";
import { CommentOutlined, BulbOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import ProductLockPage from "components/ProductLock/ProductLockPage";
import lockStyles from "components/ProductLock/style.module.scss";

const AdvisorLockPage = ({ theme, userId, onActivated }) => {
  const { t } = useTranslation();
  return (
    <ProductLockPage
      productKey="advisor"
      theme={theme}
      userId={userId}
      onActivated={onActivated}
    >
      <div className={lockStyles.lockCardGhostOne}>
        <CommentOutlined />
        <span>{t("advisor_lock.ghost_ask")}</span>
        <strong>{t("advisor_lock.ghost_live")}</strong>
      </div>
      <div className={lockStyles.lockCardGhostTwo}>
        <BulbOutlined />
        <span>{t("advisor_lock.ghost_insight")}</span>
        <strong>{t("advisor_lock.ghost_ai")}</strong>
      </div>
    </ProductLockPage>
  );
};

export default AdvisorLockPage;
